import firebase from 'firebase/app';
import 'firebase/auth';

firebase.initializeApp({
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  authDomain: 'unrulr.firebaseapp.com',
  databaseURL: 'https://unrulr.firebaseio.com',
  projectId: 'unrulr',
  storageBucket: 'unrulr.appspot.com',
  messagingSenderId: '77266829364'
});

export { firebase };
